<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>
<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'daycare.historico'|translate}}</h1>

            <button type="button" class="btn btn-gray-fill" [disabled]="loading" (click)="actionExcel()">
                <svg-icon class="right" src="assets/svg/downloads.svg"></svg-icon>{{'daycare.exportarexcel'|translate}}
            </button>
        </div>

        <div class="page-filter">
            <div class="input-material">
                <input id="keyword" [(ngModel)]="filter.keyword" (keyup.enter)="actionSearch()"
                       class="form-control" type="text" required/>
                <label for="keyword">
                    <svg-icon [svgClass]="'input-search'" src="assets/svg/search.svg"></svg-icon>
                    <span>{{'busca'|translate}}</span>
                </label>
            </div>

            <div class="input-material">
                <input id="startDate" [(ngModel)]="filter.startDate" class="form-control" type="date"/>
                <label for="startDate" class="mb-0 mr-3">{{'daycare.de'|translate}}</label>
            </div>
            <div class="input-material">
                <input id="endDate" [(ngModel)]="filter.endDate" class="form-control" type="date"/>
                <label for="endDate" class="mb-0 mr-3">{{'daycare.ate'|translate}}</label>
            </div>

            <!-- Filtro por estado da estadia (Fatia 8B) -->
            <div class="input-material">
                <select id="status" [(ngModel)]="filter.status" class="form-control">
                    <option value="">{{'daycare.statustodos'|translate}}</option>
                    <option value="in">{{'daycare.statusdentro'|translate}}</option>
                    <option value="out">{{'daycare.statusjasairam'|translate}}</option>
                </select>
                <label for="status" class="mb-0 mr-3">{{'daycare.status'|translate}}</label>
            </div>

            <div class="input-material" *ngIf="showUnitySelector">
                <select id="unity" [(ngModel)]="filter.unityId" class="form-control">
                    <option [ngValue]="null">{{'todasunidades'|translate}}</option>
                    <option *ngFor="let u of unities" [ngValue]="u.id">{{u.name}}</option>
                </select>
                <label for="unity" class="mb-0 mr-3">{{'unidade'|translate}}</label>
            </div>

            <button type="button" (click)="actionSearch()" class="btn btn-primary btn-lg text-white" [disabled]="loading">
                {{'settings.dosearch'|translate}}
            </button>
            <button type="button" (click)="clearFilter()" class="btn btn-secondary btn-lg text-white" [disabled]="loading">
                <span>{{'limpar'|translate}}</span>
            </button>
        </div>

        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                <tr>
                    <th scope="col">{{'crianca'|translate}}</th>
                    <th scope="col">{{'colaborador'|translate}} ({{'re'|translate}})</th>
                    <th scope="col">{{'daycare.entrouas'|translate}}</th>
                    <th scope="col">{{'daycare.trazidapor'|translate}}</th>
                    <th scope="col">{{'daycare.saiuas'|translate}}</th>
                    <th scope="col">{{'daycare.retiradapor'|translate}}</th>
                    <th scope="col">{{'daycare.status'|translate}}</th>
                    <th scope="col">{{'daycare.observacao'|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="isNullOrUndefined(page.results) || page.results.length === 0">
                    <td colspan="8">
                        <p class="text-center my-5">{{'daycare.nenhumaretirada'|translate}}</p>
                    </td>
                </tr>
                <tr *ngFor="let r of page.results |
                paginate: {itemsPerPage: page.PageSize, currentPage: page.currentPage, totalItems: page.totalCount}">
                    <td>{{ r.childName }}</td>
                    <td>{{ r.employeeRe }}</td>

                    <!-- Entrou às: hora, ou o entryNote (marcador "entrada não registrada"), ou — -->
                    <td>
                        <span *ngIf="r.entryAt">{{ r.entryAt | date:'dd/MM/yyyy HH:mm' }}</span>
                        <span *ngIf="!r.entryAt && r.entryNote" class="text-muted font-italic">{{ r.entryNote }}</span>
                        <span *ngIf="!r.entryAt && !r.entryNote" class="text-muted">—</span>
                    </td>

                    <!-- Trazida por + vínculo -->
                    <td>
                        <ng-container *ngIf="r.entryPersonName">
                            {{ r.entryPersonName }}
                            <span class="badge badge-info" *ngIf="isEmployee(r.entryPersonKind)">{{'daycare.colaboradorvinculo'|translate}}</span>
                            <span class="badge badge-primary" *ngIf="isParent(r.entryPersonKind)">{{'paimae'|translate}}</span>
                            <span class="badge badge-light" *ngIf="r.entryPersonKind && !isEmployee(r.entryPersonKind) && !isParent(r.entryPersonKind)">{{'daycare.autorizado'|translate}}</span>
                        </ng-container>
                        <span *ngIf="!r.entryPersonName" class="text-muted">—</span>
                    </td>

                    <!-- Saiu às: se DENTRO, vazio; senão hora, ou exitNote, ou — -->
                    <td>
                        <span *ngIf="r.status === 'in'" class="text-muted">—</span>
                        <ng-container *ngIf="r.status !== 'in'">
                            <span *ngIf="r.exitAt">{{ r.exitAt | date:'dd/MM/yyyy HH:mm' }}</span>
                            <span *ngIf="!r.exitAt && r.exitNote" class="text-muted font-italic">{{ r.exitNote }}</span>
                            <span *ngIf="!r.exitAt && !r.exitNote" class="text-muted">—</span>
                        </ng-container>
                    </td>

                    <!-- Retirada por: se DENTRO, vazio; senão nome + vínculo -->
                    <td>
                        <span *ngIf="r.status === 'in'" class="text-muted">—</span>
                        <ng-container *ngIf="r.status !== 'in' && r.exitPersonName">
                            {{ r.exitPersonName }}
                            <span class="badge badge-info" *ngIf="isEmployee(r.exitPersonKind)">{{'daycare.colaboradorvinculo'|translate}}</span>
                            <span class="badge badge-primary" *ngIf="isParent(r.exitPersonKind)">{{'paimae'|translate}}</span>
                            <span class="badge badge-light" *ngIf="r.exitPersonKind && !isEmployee(r.exitPersonKind) && !isParent(r.exitPersonKind)">{{'daycare.autorizado'|translate}}</span>
                        </ng-container>
                        <span *ngIf="r.status !== 'in' && !r.exitPersonName" class="text-muted">—</span>
                    </td>

                    <!-- Status -->
                    <td>
                        <span class="badge badge-success" *ngIf="r.status === 'in'">{{'daycare.dentro'|translate}}</span>
                        <span class="badge badge-secondary" *ngIf="r.status !== 'in'">{{'daycare.fora'|translate}}</span>
                    </td>

                    <!-- Obs.: notas reais (quando o horário existe, a nota é observação, não marcador) -->
                    <td>
                        <div *ngIf="r.entryAt && r.entryNote"><small>{{'daycare.entrada'|translate}}: {{ r.entryNote }}</small></div>
                        <div *ngIf="r.exitAt && r.exitNote"><small>{{'daycare.saida'|translate}}: {{ r.exitNote }}</small></div>
                        <span *ngIf="!(r.entryAt && r.entryNote) && !(r.exitAt && r.exitNote)" class="text-muted">—</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="text-right">
            <pagination-controls
                    [previousLabel]="labels.previousLabel"
                    [nextLabel]="labels.nextLabel"
                    [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                    [screenReaderPageLabel]="labels.screenReaderPageLabel"
                    [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel"
                    (pageChange)="pageChanged($event)"></pagination-controls>
        </div>
    </div>
</div>
